import { useRef, useEffect } from "react";

/**
 * Custom hook to run additional side effects on update
 *
 * @param {function} fn
 * @param {array} deps
 * @param {function} onUpdateFn
 */
const useAdditionalUpdateEffect = (fn, deps, onUpdateFn) => {
    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            onUpdateFn(); // Run this only on update
        }
        fn(); // Run this on mount && update
    }, [deps]);
};

export default useAdditionalUpdateEffect;
